<template>
  <div>
    <v-card>
      <v-img max-height="85" src="@/assets/img/background.png">
        <v-app-bar flat class="mt-2" color="rgba(0, 0, 0, 0)">
          <v-btn color="white" @click="goBack()" icon>
            <v-icon>mdi-chevron-left</v-icon>
          </v-btn>
          <p class="text-white-title mt-4">Pinjaman</p>
        </v-app-bar>
      </v-img>
    </v-card>
    <div v-if="showData">
      <v-sheet
        :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`"
        class="pa-3"
      >
        <v-skeleton-loader
          class="mx-auto"
          max-width="300"
          type="card"
        ></v-skeleton-loader>
      </v-sheet>
    </div>
    <div v-else class="mx-3">
      <div style="max-width: 400px;" class="mx-auto mt-3">
        <p class="app-subtitle mb-0">Filter:</p>
        <v-btn
          @click="filterCate(true)"
          rounded
          class="my-3 mx-1"
          v-bind:color="filter ? 'primary' : 'grey-light'"
          >Lunas</v-btn
        >
        <v-btn
          class="my-3 mx-1"
          rounded
          @click="filterCate(false)"
          v-bind:color="!filter ? 'primary' : 'grey-light'"
          >Belum Lunas</v-btn
        >
      </div>
      <div
        class="mx-3 w-100 d-flex justify-center"
        outlined
        min-height="600px"
        v-if="res_pinjaman.length < 1"
      >
        <div class="not-found text-center d-flex flex-column  justify-center">
          <img
            src="@/assets/img/data_not_found.png"
            class="img-not-found-center"
            alt="Data Not Found"
          />
          <p class="text-bold-xl my-0 py-0">Anda tidak memiliki pinjaman</p>
        </div>
      </div>
      <div
        class="ma-3"
        :key="index.id"
        v-for="(row, index) in res_pinjaman"
        v-else
      >
        <v-card
          class="mx-auto bg-abstract"
          :color="row.paid_off ? '#ff9a47' : '#fb6a52'"
          dark
          max-width="400"
        >
          <div class="opticality">
            <v-card-title>
              <div>
                <p class="text-grey pb-0 mb-0">
                  {{ row.borrow_code.formated }}
                </p>
              </div>
              <v-spacer></v-spacer>
              <v-btn
                v-if="row.paid_off !== true"
                @click="goToDetail(row)"
                fab
                dark
                small
                color="white"
              >
                <v-icon large color="black">
                  mdi-chevron-right
                </v-icon>
              </v-btn>
            </v-card-title>

            <v-card-text class="">
              <p class="mb-0 pb-0">Jumlah pinjaman:</p>
              <p class="text-white-xl">{{ row.borrowed_amount | currency }}</p>
            </v-card-text>

            <v-card-actions>
              <v-list-item class="grow">
                <v-list-item-content>
                  <v-list-item-title>
                    <span class="text-white-sm">{{ row.borrow_date }}</span>
                  </v-list-item-title>
                </v-list-item-content>

                <v-row align="center" justify="end">
                  <div v-if="row.paid_off === true">
                    <v-icon class="mr-1">
                      mdi-checkbox-multiple-marked-circle-outline
                    </v-icon>
                    <span class="subheading mr-2">Lunas</span>
                  </div>
                  <div v-else>
                    <v-icon class="mr-1">
                      mdi-cash
                    </v-icon>
                    <span class="subheading">Belum Lunas</span>
                  </div>
                </v-row>
              </v-list-item>
            </v-card-actions>
          </div>
        </v-card>
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const loginData = createNamespacedHelpers("login");
const pinjaman = createNamespacedHelpers("pinjaman");

export default {
  name: "Home",
  panel: [],
  switch1: false,
  showData: true,
  menu1: false,
  menu2: false,
  endDate: ["2019-09-10", "2019-09-20"],
  inject: {
    theme: {
      default: { isDark: false }
    }
  },
  computed: {
    ...loginData.mapState(["res_userInfo"]),
    ...pinjaman.mapState(["res_pinjaman", "filter"])
  },
  mounted() {
    this.$store
      .dispatch("login/getUserInfo")
      .then(response => {
        const res = response.data;
        console.log(res.data);
        this.$store.commit("pinjaman/SET_NOA", res.data.noa);
        this.$store.dispatch("pinjaman/getPinjaman");
        this.showData = false;
      })
      .catch(error => {
        const message = error.response.data.message;
        console.log(message);
      });
  },
  data() {
    return {
      url: process.env.VUE_APP_URL,
      categoryChart: [],
      show: true,
      showSaham: false,
      showNonSaham: true
    };
  },
  components: {},
  watch: {},
  methods: {
    goToDetail(val) {
      console.log(val);
      this.$store.commit("pinjaman/SET_MASTERPINJAM", val);
      this.$store.commit("pinjaman/SET_MUTATION", null);
      this.$store.commit("pinjaman/SET_REYMUTASIPINJAMAN", []);
      this.$store.commit("pinjaman/SET_MUTATION", val.nospp);
      this.$router.push("/pinjaman/mutation");
    },
    filterCate(val) {
      this.$store.commit("pinjaman/SET_FILTER", val);
      this.$store.dispatch("pinjaman/getPinjaman");
    },
    goBack() {
      this.$router.go(-1);
    }
  }
};
</script>
